var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMortarPestle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.5 60.875C518.75 43.75 514 14.625 492.25 3.75C480.125 -2.25 465.75 -1 454.875 7.125L251.125 160H402.5L501.5 60.875ZM496 192H16C7.125 192 0 199.125 0 208V240C0 248.875 7.125 256 16 256H32C32 337 82.25 406.125 153.125 434.375C140.375 451.25 131.375 471.125 128.125 493C126.75 502.875 134.25 512 144.25 512H367.75C377.75 512 385.25 502.875 383.875 493C380.625 471.125 371.625 451.25 358.875 434.375C429.75 406.125 480 337 480 256H496C504.875 256 512 248.875 512 240V208C512 199.125 504.875 192 496 192Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortarPestle);
export default __webpack_public_path__ + "static/media/mortar-pestle.6903a19ae4f76bae09d961aa8af5198d.svg";
export { ForwardRef as ReactComponent };